import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from '~/core/components/contexts/UserContext';
import { positions, AlertProvider, AlertTemplate } from '~/core/presentation/widgets/ui/notification/index';
import Main from '~/core/components/root/Main';

const options = {
  timeout: 5000,
  position: positions.BOTTOM_CENTER,
};
export const App = (): JSX.Element => (
  <HelmetProvider>
    <AlertProvider template={AlertTemplate} {...options}>
      <AuthProvider>
        <Main />
      </AuthProvider>
    </AlertProvider>
  </HelmetProvider>
);
